<p>{{ 'inquiry.closeInquiry.confirmationText' | translate }}</p>
<form [formGroup]="closeInquiryForm">
  <div class="form-group">
    <base-dropdown
      [items]="inquiryCloseReasons"
      formControlName="reason"
      [translateItems]="true"
      [searchable]="false"
      [requiredLabel]="true"
      outputModel="id"
      bindOptionLabel="label"
      placeholder="inquiry.rejectReasonPlaceholder"
    >
    </base-dropdown>
  </div>
  <div class="form-group mb-0">
    <base-textarea
      formControlName="justification"
      [placeholder]="textareaPlaceholder"
      [rows]="2"
    >
    </base-textarea>
  </div>
</form>
<div class="modal-footer px-0 py-3 w-100">
  <base-button
    [size]="buttonSizes.md"
    color="secondary"
    label="action.cancel"
    class="me-3"
    (btnClick)="modalRef.dismiss()"
  ></base-button>
  <base-button
    [size]="buttonSizes.md"
    color="primary"
    label="action.yesClose"
    (btnClick)="closeInquiry()"
  ></base-button>
</div>
